<div class="input-container" data-testid="input-editor-container">
  <div class="input-wrapper" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <input
      #inputWithOptions
      type="text"
      class="ag-input-field-input ag-text-field-input"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [maxLength]="maxLength"
      (focusin)="showTooltip.set(true)"
      (focusout)="showTooltip.set(false)"
      (blur)="onBlur()"
      [style.width.px]="cellWidth"
      [style.height.px]="cellHeight"
      data-testid="input-editor-input"
      [matAutocomplete]="auto"
    />

    @if (showClearIcon()) {
    <mat-icon
      class="clear-icon"
      tabindex="0"
      role="button"
      (click)="clearInput($event); inputWithOptions.blur()"
      (keydown.enter)="clearInput($event); inputWithOptions.blur()"
      data-testid="input-editor-clear-icon"
      >close</mat-icon
    >
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      [panelWidth]="panelWidth"
      [displayWith]="displayWith"
      [class]="
        autocompletePanelClass +
        (noResults() ? ' custom-autocomplete--no-results' : '') +
        (showMinSearchError() ? ' custom-autocomplete--min-search' : '')
      "
    >
      @if (enableAutocomplete) {
      <div class="options-container" (scroll)="onScroll($event)">
        <mat-option
          (mousedown)="onOptionSelected(option)"
          *ngFor="let option of filteredOptions$ | async"
          [value]="option"
        >
          <div class="autocomplete-option">
            <div class="autocomplete-option-primary">
              {{ optionDisplayWith(option).primary }}
            </div>

            @if (optionDisplayWith(option).secondary) {
            <div class="autocomplete-option-secondary">
              {{ optionDisplayWith(option).secondary }}
            </div>
            }
          </div>
        </mat-option>

        @if(loader()){
        <mat-option class="loader-option" data-testid="autocomplete-loader">
          <div class="center">
            <mat-spinner diameter="20"></mat-spinner>
            @if (loaderText) {
            <div>{{ loaderText }}</div>
            }
          </div>
        </mat-option>
        } @if(showMinSearchError()){
        <mat-option class="min-search-option" disabled>
          {{ minSearchMessage }}
        </mat-option>
        } @if (!loader() && showNoResultsOption && noResults()) {
        <mat-option
          class="no-results-option"
          disabled
          data-testid="autocomplete-no-results"
        >
          {{ noResultsText }}
        </mat-option>
        }
      </div>
      }
    </mat-autocomplete>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="
      !enableAutocomplete && showTooltip() && searchControl.value?.length > 0
    "
    [cdkConnectedOverlayOffsetY]="5"
  >
    <div class="tooltip" data-testid="input-editor-tooltip">
      <div class="tooltip-content">
        Max Characters: {{ searchControl.value?.length || 0 }}/{{ maxLength }}
        <img class="error-icon" src="/images/notification2.svg" alt="error" />
      </div>
      <div class="tooltip-pointer"></div>
    </div>
  </ng-template>
</div>
